import React, { useState } from 'react';
import FolderIcon from '../components/folderIcon';

const LandingPage = ({ theme, folders, onFolderClick }) => {
  const [hoveredFolder, setHoveredFolder] = useState(null);
  return (
    <div className='draggableLanding'>
      <h3>Developer, Illustrator, Animator</h3>
      <p>This window appeared because you clicked the bunny!</p>
      <div className="folderChoices">
        {folders.map((folder) => (
          <div
            key={folder.id}
            onMouseEnter={() => setHoveredFolder(folder.id)}
            onMouseLeave={() => setHoveredFolder(null)}
          >
            <FolderIcon
              theme={theme}
              label={folder.label}
              isHovered={hoveredFolder === folder.id}
              onClick={() => onFolderClick(folder.id)}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default LandingPage;